import { render, staticRenderFns } from "./ShowCollapsibleCardBtns.vue?vue&type=template&id=87aa017e"
import script from "./ShowCollapsibleCardBtns.vue?vue&type=script&lang=ts"
export * from "./ShowCollapsibleCardBtns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports